<template>
  <Modal :open="!!announcement" size="medium" @close="close">
    <AnnouncementContent
      v-if="displayedAnnouncement"
      :content="displayedAnnouncement.content"
      :role="currentUser.role"
      @dismiss="close"
    />
  </Modal>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { Modal } from "@estaly/ui";
import AnnouncementContent from "@/components/announcement/AnnouncementContent.vue";

// Shows the announcements targeting the signed-in merchant user, as served by the API: the first one not
// closed yet at sign-in, or the one reopened from the sidebar.
export default {
  components: { Modal, AnnouncementContent },

  props: {
    currentUserId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      // Kept while the modal plays its closing transition, so the content does not vanish first
      displayedAnnouncement: null,
    };
  },

  computed: {
    ...mapState("auth", ["currentUser"]),
    ...mapGetters("auth", ["isMerchantProfile"]),
    ...mapGetters("announcements", { announcement: "modalAnnouncement" }),
  },

  watch: {
    currentUserId: {
      handler() {
        if (this.isMerchantProfile) this.fetchIndex();
      },
      immediate: true,
    },

    announcement: {
      handler(announcement) {
        if (announcement) this.displayedAnnouncement = announcement;
      },
      immediate: true,
    },
  },

  methods: {
    ...mapActions("announcements", { fetchIndex: "fetchIndex", closeAnnouncement: "close" }),

    close() {
      if (this.announcement) this.closeAnnouncement(this.announcement.slug);
    },
  },
};
</script>
